import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { ToastService } from '@core/services/toast.service';
import { environment } from '@env/environment';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-permission-and-roles',
    templateUrl: './permission-and-roles.component.html',
    styleUrls: ['./permission-and-roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PermissionAndRolesComponent implements OnInit {
  private storageUrl = environment.storageUrl;
  toastService = inject(ToastService);
  downloadFile: { label: string; icon: string; description: string }[] = [];

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.buildDownloadFile();
  }

  private buildDownloadFile(): void {
    this.downloadFile = [
      {
        label: this.translocoService.translate('resource.permissionAndRoles.fileLabel'),
        icon: 'uil uil-file-download',
        description: this.translocoService.translate('resource.common.download'),
      },
    ];
  }

  downloadReport(): void {
    const fileUrl = `${this.storageUrl}drdp-rebuild-resources/DRDP Online Roles and Permissionsv15.pdf`;
    this.fetchAndDownloadFile(fileUrl, 'DRDP Roles and Permissions');
  }

  private fetchAndDownloadFile(fileUrl: string, fileName: string) {
    const link = document.createElement('a');
    link.style.display = 'none';

    fetch(fileUrl)
      .then(response => {
        if (!response.ok) {
          this.toastService.error(this.translocoService.translate('resource.common.downloadFailedToast'));
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        this.toastService.error(this.translocoService.translate('resource.common.downloadFailedToast'));
      })
      .finally(() => {
        document.body.removeChild(link);
      });

    document.body.appendChild(link);
  }

}
